import React, { useContext } from "react";

import styled from "styled-components";

import JobAlertForm from "../../../components/JobAlertForm/JobAlertForm";
import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import Button from "../Button/Button";

const StyledButtonWrapper = styled.div`
  width: ${({ buttonWidth }) => buttonWidth || "120px"};
  height: ${({ height }) => height || "80px"};
  margin: 0 auto;
`;

function JobAlertButton() {
  const { modalStore } = useStores();
  const { openModal } = modalStore;

  const {
    agreementContent = "By clicking the button, you agree to our",
    buttonWidth = "120px",
    privacyPolicyLink = "/",
    formHeaderBackgroundColour = "",
    inputHeight = "80px",
    buttonText = "Sign Up",
  } = useContext(ComponentContext);

  const onClick = () => {
    openModal({
      content: (
        <JobAlertForm
          agreementContent={agreementContent}
          privacyPolicyLink={privacyPolicyLink}
          formHeaderBackgroundColour={formHeaderBackgroundColour}
        />
      ),
      size: "md",
    });
  };

  return (
    <StyledButtonWrapper buttonWidth={buttonWidth} height={inputHeight}>
      <Button
        className="text-uppercase"
        height="100%"
        onClick={onClick}
        type="button"
      >
        {buttonText}
      </Button>
    </StyledButtonWrapper>
  );
}

export default JobAlertButton;
